module.exports = __webpack_public_path__ + "img/configuracaoFill.819e87ce.svg";